<div class="location-picker">
  @if (!readOnly()) {
    <div class="mb-2 position-relative">
      <label class="form-label fw-semibold text-dark small mb-1">Buscar dirección *</label>
      <div class="input-group input-group-sm">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
        <input
          type="search"
          class="form-control"
          [ngModel]="query()"
          (ngModelChange)="onQueryInput($event)"
          placeholder="Escribe calle, comuna o ciudad..."
          autocomplete="off">
        <button type="button" class="btn btn-outline-primary" (click)="useMyLocation()" title="Usar mi ubicación">
          <i class="fas fa-location-crosshairs"></i>
        </button>
      </div>
      @if (loading()) {
        <div class="text-muted small mt-1"><i class="fas fa-spinner fa-spin me-1"></i>Buscando...</div>
      }
      @if (suggestions().length) {
        <ul class="suggestions list-unstyled mb-0">
          @for (item of suggestions(); track item.fullName + item.lat) {
            <li>
              <button type="button" class="suggestion-item" [title]="item.fullName" (mousedown)="selectSuggestion(item)">
                <i class="fas fa-map-marker-alt me-2 text-danger"></i>
                <span class="suggestion-main">{{ item.displayName }}</span>
                @if (item.fullName !== item.displayName) {
                  <span class="suggestion-full">{{ item.fullName }}</span>
                }
              </button>
            </li>
          }
        </ul>
      }
      @if (geoError()) {
        <div class="text-danger small mt-1">{{ geoError() }}</div>
      }
    </div>
  }

  <div #mapEl class="location-map"></div>

  <div class="location-meta mt-2">
    @if (currentAddress()) {
      <div class="location-saved" [class.text-muted]="readOnly()">
        <i class="fas fa-map-marker-alt me-1 text-danger"></i>
        <strong>{{ currentAddress() }}</strong>
      </div>
    } @else if (readOnly()) {
      <div class="text-muted small">No registrada</div>
    } @else {
      <div class="text-muted small">Elige un resultado, el mapa o tu ubicación</div>
    }

    <div class="coords text-muted small mt-1">
      @if (currentLat() != null && currentLng() != null) {
        <span>Lat: {{ currentLat() | number:'1.5-5' }} · Lng: {{ currentLng() | number:'1.5-5' }}</span>
      }
    </div>
  </div>
</div>
